import type { JSX } from 'react';
import { FormSection, Radio } from '@ksyos/design-system';
import type { Vervolgstap } from '@common/customControls/bariatrics';
import type { BariPostCaroInactivityReportData } from '@common/validation/customControls/bariPost/bariPostCaroInactivityPoliReport/v1/bariPostCaroInactivityPoliReportSchemaV1';
import {
    RadioGroupFormGroup,
    TextAreaFormGroup,
} from '@frontend/components/pages/episodeCategory/customControls/processActivityFormGroupFields';
import { useProcessActivityEditContext } from '@frontend/utils';
import { BariPostCaroInactivity } from './BariPostCaroInactivity';

type BariPostCaroInactivityPoliFormEditProps = Readonly<{
    showReportCounts?: boolean;
    vervolgStappen: Vervolgstap[];
}>;

export function BariPostCaroInactivityFormEdit(props: BariPostCaroInactivityPoliFormEditProps): JSX.Element {
    const { showReportCounts, vervolgStappen } = props;
    const { processActivityId } = useProcessActivityEditContext<BariPostCaroInactivityReportData>();

    return (
        <FormSection>
            <BariPostCaroInactivity
                showReportCounts={showReportCounts}
                untilProcessActivityId={processActivityId ?? undefined}
            />
            <TextAreaFormGroup
                fieldKey="verslag"
                isRequired={true}
                label="Verslag"
            />
            <RadioGroupFormGroup
                fieldKey="vervolgstap"
                isRequired={true}
                label="Vervolgstap"
            >
                {vervolgStappen.map((value) => (
                    <Radio
                        key={value}
                        label={value}
                        value={value}
                    />
                ))}
            </RadioGroupFormGroup>
        </FormSection>
    );
}
